import qs from 'qs'

interface Params {
  parsed: ParsedParams
  search: string
  href: string
}

class QueryParamsClass {
  private params: Params = {
    parsed: {},
    search: '',
    href: '',
  }

  public parseQueryParams = (search = '', options: qs.IStringifyOptions = {}) => {
    if (!search || !search?.slice(1)) return {}

    return qs.parse(search, {
      ignoreQueryPrefix: true,
      depth: 5,
      ...options,
    })
  }

  public stringifyQueryParams = (data: ParsedParams, options: qs.IStringifyOptions = {}) =>
    qs.stringify(data, {
      skipNulls: true,
      addQueryPrefix: true,
      arrayFormat: 'brackets',
      ...options,
    })

  public getParams() {
    if (this.currentSearch !== this.params.search) {
      const parsedParams = this.parseQueryParams(this.currentSearch) || {}

      this.params.parsed = parsedParams
      this.params.search = this.currentSearch
      this.params.href = this.getHrefWithParams(this.currentSearch)
    }

    return this.params
  }

  public updateParams(newParams: ParsedParams) {
    const currentParsedParams = this.parseQueryParams(this.currentSearch) || {}

    const params = {
      ...currentParsedParams,
      ...newParams,
    }

    const stringifiedParams = this.stringifyQueryParams(params)

    this.params.parsed = params
    this.params.search = stringifiedParams
    this.params.href = this.getHrefWithParams(stringifiedParams)

    return this.params
  }

  private getHrefWithParams(params: string) {
    if (typeof window === 'undefined') return ''

    return window.location.origin + window.location.pathname + params
  }

  private get currentSearch() {
    if (typeof window === 'undefined') return ''

    return window.location.search
  }
}

const QueryParams = new QueryParamsClass()

export default QueryParams
